import dayjs from "dayjs";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "ID",
    model: "id",
    required: true,
    readonly: true,
    visible: (model) => model.id
  },
  {
    type: "bsx-upload",
    label: "Banner 圖片",
    help: "寬：1030 px, 高：450 px",
    model: "image",
    kind: "button",
    required: true,
    browse: true,
    preview: true,
    accept: ".jpg,.png",
    folder: "banner",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "開啟類型",
    model: "open_type",
    required: true,
    values: [
      { id: "IN_APP", name: "在應用內開啟" },
      { id: "WEB_BROWSER", name: "在瀏覽器中開啟" },
      { id: "NO_WINDOW", name: "不開啟新視窗" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "目的頁網址",
    model: "url",
    placeholder: "請輸入目的頁網址",
    required: (model) => model.open_type != 'NO_WINDOW',
    disabled: (model) => model.open_type == 'NO_WINDOW',
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "發布狀態",
    model: "visibility_rule",
    required: true,
    values: [
      { id: "ALWAYS_ONLINE", name: "上架" },
      { id: "ALWAYS_OFFLINE", name: "下架" },
      { id: "BY_DATE", name: "依時間發布" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-groupTitle",
    label: "發布期間",
    readonly: true,
    visible: (model) => model && model.visibility_rule == "BY_DATE",
  },
  {
    type: "bsx-dateTimePicker",
    label: "上架時間",
    model: "begin_at",
    placeholder: "請選擇日期",
    required: (model) => model && model.visibility_rule == "BY_DATE",
    hideClockIcon: true,
    //visible: (model) => model && model.visibility_rule == "BY_DATE",
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-dateTimePicker",
    label: "下架時間",
    help: "若此欄位空，則視為無下架時間",
    model: "end_at",
    placeholder: "請選擇日期",
    hideClockIcon: true,
    //visible: (model) => model && model.visibility_rule == "BY_DATE",
    validator: function () {
      this.validation();

      let beginAt = dayjs(this.model.begin_at, "YYYY-MM-DD HH:mm:ss", true);
      let endAt = dayjs(this.model.end_at, "YYYY-MM-DD HH:mm:ss", true);

      if (beginAt.isValid() && endAt.isValid()) {
        if (!beginAt.isBefore(endAt)) {
          this.inputError = true;
          this.dateErrorMessage = "結束時間須晚於開始時間";
        }
      }
    },
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "權重",
    help: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "請輸入權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
];

export default fields;
